import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import SetGroupItem from '../item/setGroupItem';
import AbstractCommand from './abstractCommand';

/**
 * Add item command
 *
 * @class AddItemCommand
 * @extends AbstractCommand
 */
export default class AddItemCommand extends AbstractCommand {
    /**
     * @param {ItemCollection} itemCollection
     * @param {SelectionCollection} selection
     * @param {ItemInterface[]|ItemInterface} items
     * @param {ContextManager} contextManager
     */
    constructor(itemCollection, selection, items, contextManager = null) {
        super();
        this.itemCollection = itemCollection;
        this.selection = selection;
        this.items = Array.isArray(items) ? items : [items];
        this.contextManager = contextManager;

        if (contextManager) this.initialContext = contextManager.getCurrentContext();
    }

    isValid() {
        return !this.items.find(item => !item.getParentItem().isItemSupported(item));
    }

    /**
     * Execute command
     */
    execute() {
        if (!this.isValid()) {
            this.abort();
            return;
        }

        const parameters = {
            showAccessory: true,
            showInitialVersion: true,
        };

        if (this.items.length === 1) {
            parameters.showAlignment = this.items[0] instanceof SetGroupItem;
        }

        this.itemCollection.add(this.items);

        if (this.selection) {
            this.selection.selectItems(this.items, true, parameters);
        }

        if (this.contextManager) {
            this.contextManager.switchContext(this.contextManager.findNearestContextByItem(this.items[0]));
        }
    }

    /**
     * Unexecute command
     */
    unexecute() {
        this.itemCollection.remove(this.items);

        if (this.selection) {
            this.selection.clear();
        }

        if (this.contextManager && this.initialContext) {
            this.contextManager.switchContext(this.initialContext);
        }
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        return `Add ${this.items.length > 1 ? 'items' : this.items[0].attributes.type}`;
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.AddItemCommand = AddItemCommand;
